/*
 * Gentle Morrow - cart boost
 *
 * 1. Free gift threshold: adds a $0.00 gift variant to the cart once the
 *    non-gift subtotal reaches the threshold, and removes it if the cart
 *    drops back below. The gift is $0.00, so adding it cannot change the
 *    subtotal - there is no oscillation risk.
 * 2. In-cart upsell: one-tap add for the product the cart snippet picked.
 *
 * The <gm-cart-boost> custom element is the sync hook. Every cart mutation
 * makes Dawn re-render .drawer__inner / .js-contents, which re-inserts the
 * element and fires connectedCallback again.
 */
(function () {
  'use strict';

  function cfg() {
    return window.GM_CART_BOOST || {};
  }

  function routes() {
    return window.routes || {};
  }

  var busy = false;
  var timer = null;

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) {
      return r.json();
    });
  }

  function sectionInner(html, selector) {
    try {
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return el ? el.innerHTML : null;
    } catch (e) {
      return null;
    }
  }

  /* Re-render the cart regions Dawn owns, the same way Dawn does. */
  function refresh() {
    var want = [];
    var drawerInner = document.querySelector('#CartDrawer .drawer__inner');
    var bubble = document.getElementById('cart-icon-bubble');
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');

    if (drawerInner) want.push('cart-drawer');
    if (bubble) want.push('cart-icon-bubble');
    if (items && items.dataset.id) want.push(items.dataset.id);
    if (footer && footer.dataset.id) want.push(footer.dataset.id);
    if (!want.length) return Promise.resolve();

    return fetch(window.location.pathname + '?sections=' + want.join(','), { cache: 'no-store' })
      .then(function (r) {
        return r.json();
      })
      .then(function (s) {
        if (drawerInner && s['cart-drawer']) {
          var d = sectionInner(s['cart-drawer'], '.drawer__inner');
          if (d !== null) drawerInner.innerHTML = d;
        }
        if (bubble && s['cart-icon-bubble']) {
          var b = sectionInner(s['cart-icon-bubble'], '.shopify-section');
          if (b !== null) bubble.innerHTML = b;
        }
        [
          [items, s[items && items.dataset.id]],
          [footer, s[footer && footer.dataset.id]],
        ].forEach(function (pair) {
          if (!pair[0] || !pair[1]) return;
          var target = pair[0].querySelector('.js-contents');
          var html = sectionInner(pair[1], '.js-contents');
          if (target && html !== null) target.innerHTML = html;
        });
        markGiftLine();
      })
      .catch(function () {
        /* a stale cart UI is recoverable on next navigation - never throw */
      });
  }

  /* Dim the quantity stepper on the gift row so it does not look editable. */
  function markGiftLine() {
    var handle = cfg().giftHandle;
    if (!handle) return;
    var rows = document.querySelectorAll('.cart-item');
    for (var i = 0; i < rows.length; i++) {
      var link = rows[i].querySelector('a[href*="/products/"]');
      if (link && link.getAttribute('href').indexOf(handle) !== -1) {
        rows[i].classList.add('gm-boost-gift-line');
      }
    }
  }

  function evaluate() {
    var c = cfg();
    var giftId = parseInt(c.giftVariantId, 10);
    var threshold = parseInt(c.thresholdCents, 10);
    if (busy || !giftId || !threshold) return;

    busy = true;
    fetch((routes().cart_url || '/cart') + '.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var giftQty = 0;
        var subtotal = 0;
        (cart.items || []).forEach(function (it) {
          if (it.variant_id === giftId) {
            giftQty += it.quantity;
          } else {
            subtotal += it.final_line_price;
          }
        });

        /* An empty cart never qualifies, even though 0 >= 0 would pass. */
        var qualifies = cart.item_count > giftQty && subtotal >= threshold;

        if (qualifies && giftQty === 0) {
          return postJSON(routes().cart_add_url || '/cart/add.js', {
            items: [{ id: giftId, quantity: 1 }],
          }).then(refresh);
        }
        if (!qualifies && giftQty > 0) {
          return postJSON(routes().cart_change_url || '/cart/change.js', {
            id: String(giftId),
            quantity: 0,
          }).then(refresh);
        }
        if (qualifies && giftQty > 1) {
          return postJSON(routes().cart_change_url || '/cart/change.js', {
            id: String(giftId),
            quantity: 1,
          }).then(refresh);
        }
        markGiftLine();
        return null;
      })
      .then(function () {
        busy = false;
      })
      .catch(function () {
        busy = false;
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(evaluate, 60);
  }

  /* ---------- in-cart upsell ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-gm-upsell-add]');
    if (!btn || btn.hasAttribute('disabled')) return;

    e.preventDefault();
    var variantId = parseInt(btn.getAttribute('data-gm-upsell-add'), 10);
    if (!variantId) return;

    btn.setAttribute('disabled', 'disabled');
    btn.textContent = 'Adding…';

    postJSON(routes().cart_add_url || '/cart/add.js', {
      items: [{ id: variantId, quantity: 1 }],
    })
      .then(refresh)
      .then(schedule)
      .catch(function () {
        btn.removeAttribute('disabled');
        btn.textContent = 'Add';
      });
  });

  /* ---------- sync hook ---------- */
  if (window.customElements && !customElements.get('gm-cart-boost')) {
    customElements.define(
      'gm-cart-boost',
      class extends HTMLElement {
        connectedCallback() {
          schedule();
        }
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
